import InPageBannerSimpleRepository from "../InPageBannerSimpleRepository"

export default class DemoInPageBannerSimple extends InPageBannerSimpleRepository {
    static schemaId = "demo_banner"

    constructor() {
        super(DemoInPageBannerSimple.schemaId)
    }
}
